<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="header-container flex align-center justify-between">
            <div class="flex align-center">
                <div class="btn-container" @click="$router.go(-1)">
                    <div class="btn"><i class="iconfont icon-fanhui margin-right-xs"></i>返回</div>
                </div>
                <div class="btn-container max margin-left-sm">
                    <div class="btn">{{ cur_time|date_time }}</div>
                </div>
            </div>
            <div class="page-title">双暖健康守护实时监测平台</div>
            <div class="flex align-center">
                <router-link :to="`/digitize/monitoring_watcher?id=${xiaoqu_id}&name=${xiaoqu_name}`" class="btn-container mid right" v-if="xiaoqu_id">
                    <div class="btn"><i class="iconfont icon-renqun margin-right-xs"></i>监测对象</div>
                </router-link>
                <el-dropdown class="xiaoqu" trigger="click" @command="handleCommand">
                    <div class="btn-container mid right margin-left-sm">
                        <div class="btn">
                            {{ xiaoqu_name || '全部小区' }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in xiaoqus" :key="index" :command="item">{{ item.name }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>
        <div class="map-container flex-sub">
            <div ref="land_map" class="map" style="display: none"></div>
            <div class="maps">
                <img :src="mapImg" alt="">
            </div>
            <dv-border-box-8 class="jc-total-container">
                <div class="classify-title">近一月</div>
                <div class="total-container number flex align-center padding-lr margin-top-sm">
                    <i class="icon iconfont icon-xindianjiance"></i>
                    <div class="label margin-left-sm flex-sub">监测次数</div>
                    <dv-digital-flop :config="{style:style,number:[push_num],content:'{nt}'}"
                                     class="number"/>
                </div>
                <div class="total-container number flex align-center padding-lr margin-top-xs">
                    <i class="icon iconfont icon-erji-anquanfuwukaitongqingkuang"></i>
                    <div class="label margin-left-sm flex-sub">异常次数</div>
                    <dv-digital-flop :config="{style:style,number:[save_order_num],content:'{nt}'}"
                                     class="number"/>
                </div>
                <div class="total-container number flex align-center padding-lr margin-top-xs">
                    <i class="icon iconfont icon-renqun"></i>
                    <div class="label margin-left-sm flex-sub">监控人数</div>
                    <dv-digital-flop :config="{style:style,number:[jumin_equipment_num],content:'{nt}'}"
                                     class="number"/>
                </div>

                <div class="flex justify-between margin-top-sm">
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-xieyang"></i>
                            <dv-digital-flop :config="{style:style,number:[xueyang_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">血氧异常报警</div>
                    </div>
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-hamnatodynamometer"></i>
                            <dv-digital-flop :config="{style:style,number:[xueya_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">血压异常报警</div>
                    </div>
                </div>
                <div class="flex justify-between margin-top-xs">
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-xinshuai"></i>
                            <dv-digital-flop :config="{style:style,number:[xinlv_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">心率异常报警</div>
                    </div>
                    <div class="total-container baojing flex flex-direction align-center justify-center">
                        <div class="number-container flex align-center justify-center">
                            <i class="bg-icon iconfont icon-mianxingwendujitubiao"></i>
                            <dv-digital-flop :config="{style:style,number:[tiwen_order_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="label">体温异常报警</div>
                    </div>
                </div>
                <div class="total-container online flex align-center margin-top-sm">
                    <div class="flex flex-direction">
                        <div class="classify-container flex align-center">
                            <i class="icon iconfont icon-xinhao"></i>
                            <div class="label">在线设备</div>
                            <dv-digital-flop :config="{style:min_style,number:[zaixian_equipment_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                        <div class="classify-container flex align-center margin-top-xs">
                            <i class="icon iconfont icon-yuyinguanbi"></i>
                            <div class="label">离线设备</div>
                            <dv-digital-flop :config="{style:min_style,number:[lixian_equipment_num],content:'{nt}'}"
                                             class="number"/>
                        </div>
                    </div>
                    <div class="flex flex-direction align-center margin-left-sm">
                        <div class="label margin-bottom-xs">监控范围内设备</div>
                        <div class="progress-container">
                            <el-progress type="circle" stroke-linecap="butt" color="#19caff" :show-text="false" :stroke-width="22" :width="100" :percentage="fanwei_lv"></el-progress>
                            <dv-digital-flop :config="{style:min_style,number:[fanwei_lv],content:'{nt}%'}"
                                             class="number progress"/>
                        </div>
                    </div>
                </div>
            </dv-border-box-8>

            <div class="yj-total-container flex flex-direction">
                <div class="info-container flex flex-direction flex-sub">
                    <div class="classify-title self-center">一般预警</div>
                    <div class="flex flex-direction flex-sub">
                        <div class="yj-item flex align-center" v-for="(item,index) in yj_yiban_list" :key="index">
                            <div class="tip-container flex flex-direction justify-center align-center">
                                <div class="tip">{{ item.service_type|service_type }}</div>
                            </div>
                            <div class="flex flex-direction">
                                <div class="flex align-center">
                                    <div class="name">{{ item.name }}</div>
                                    <div class="phone margin-left-xs">{{ item.phone }}</div>
                                </div>
                                <div class="address margin-top-xs">{{ item.xiaoqu_name }}{{ item.building_name
                                    }}{{ item.element_name }}单元{{ item.room_name }}
                                </div>
                            </div>
                            <div class="time">{{ item.add_time }}</div>
                        </div>
                    </div>
                    <div class="flex align-center justify-between margin-tb">
                        <div class="flex align-center">
                            <div class="operate" @click="yibanLast">上一页</div>
                            <div class="page">{{ yj_yiban_page }}/{{ yj_yiban_total_page }}</div>
                            <div class="operate" @click="yibanNext">下一页</div>
                        </div>
                        <div class="operate" @click="yibanRefresh"><i class="iconfont icon-shuaxin"></i> 刷新</div>
                    </div>
                </div>
                <div class="info-container flex flex-direction  flex-sub margin-top-sm">
                    <div class="classify-title self-center">紧急预警</div>
                    <div class="flex flex-direction flex-sub">
                        <div class="yj-item xinlv flex align-center" :class="{error:item.state === 2}"
                             v-for="(item,index) in yj_jinji_list" :key="index" @click="selectItem(item)">
                            <div class="tip-container flex flex-direction justify-center ">
                                <div class="tip self-center">{{ item.service_type|service_type }}</div>
                                <div class="status">{{ item.state === 2 ? '处理中' : '已处理' }}</div>
                            </div>
                            <div class="flex flex-direction">
                                <div class="flex align-center">
                                    <div class="name">{{ item.name }}</div>
                                    <div class="phone margin-left-xs">{{ item.phone }}</div>
                                </div>
                                <div class="address margin-top-xs">{{ item.xiaoqu_name }}{{ item.building_name
                                    }}{{ item.element_name }}单元{{ item.room_name }}
                                </div>
                            </div>
                            <div class="time">{{ item.add_time }}</div>
                        </div>
                    </div>
                    <div class="flex align-center justify-between margin-tb">
                        <div class="flex align-center">
                            <div class="operate" @click="jinjiLast">上一页</div>
                            <div class="page">{{ yj_jinji_page }}/{{ yj_jinji_total_page }}</div>
                            <div class="operate" @click="jinjiNext">下一页</div>
                        </div>
                        <div class="operate" @click="jinjiRefresh"><i class="iconfont icon-shuaxin"></i> 刷新</div>
                    </div>
                </div>
            </div>
        </div>

        <yijing-dialog :dialog="yijingDialog" :detail="cur_detail" @cancelDialog="cancelDialog"></yijing-dialog>

    </div>
</template>

<script>

import * as echarts from 'echarts';
import {zhDate} from "@/utils/utils";
import geoJson from '@/utils/shijingshan.json'
import shijingshan_tudi from '@/utils/shijingshan_tudi.json'
import {dataScreenTotal, getAllXiaoQu, getSaveList, getXiangMuMap} from "@/api/tongji";
import YijingDialog from "@/views/digitize/components/YijingDialog";

export default {
    name: "monitoring",
    components: {YijingDialog},
    data() {
        return {
            xiangmu_id:'',
            mapImg:'',
            cur_time: new Date().getTime(),
            style: {
                width: '120px',
                fontSize: 26,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            min_style: {
                width: '120px',
                fontSize: 20,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                FontStyle: 'italic'
            },
            xiaoqu_id: '',
            xiaoqu_name: '',
            xiaoqus: [],

            map_data: [],

            push_num: 0,
            jumin_equipment_num: 0,
            zaixian_equipment_num: 0,
            lixian_equipment_num: 0,
            save_order_num: 0,
            xinlv_order_num: 0,
            tiwen_order_num: 0,
            xueyang_order_num: 0,
            xueya_order_num: 0,
            fanwei_lv: 0,
            loading: false,

            yj_yiban_list: [],
            yj_yiban_page: 1,
            yj_yiban_total_page: 1,

            yj_jinji_list: [],
            yj_jinji_page: 1,
            yj_jinji_total_page: 1,

            yijingDialog:false,
            cur_detail:''

        }
    },
    created() {
        this.xiangmu_id = this.$route.query.xiangmu_id
        this.getCurrentTime()
        this.getAllXiaoQu()
        this.getMap()
    },
    mounted() {
      this.onload()
    },
    methods: {
        async getMap(){
            const  res = await getXiangMuMap(this.xiangmu_id)
            this.mapImg = res.data
        },
        onload(){
            this.loading = true
            this.init()
            this.getYibanSaveList()
            this.getJinjiSaveList()
            this.setTimeoutGetData()
        },
        setTimeoutGetData(){
            setInterval(() => {
                this.init()
                this.getYibanSaveList()
                this.getJinjiSaveList()
            }, 1000 * 60)
        },
        async getAllXiaoQu() {
            let _data = await getAllXiaoQu(this.xiangmu_id)
            this.xiaoqus = [{id: '', name: '全部小区'}, ..._data.data]
        },
        async getYibanSaveList() {
            let _data = await getSaveList(this.xiaoqu_id, 2, this.yj_yiban_page, 4,this.xiangmu_id)
            this.yj_yiban_total_page = _data.total_page
            this.yj_yiban_list = _data.data
        },
        yibanLast() {
            if (this.yj_yiban_page <= 1) return
            this.yj_yiban_page--
            this.getYibanSaveList()
        },
        yibanNext() {
            if (this.yj_yiban_page === this.yj_yiban_total_page) return
            this.yj_yiban_page++
            this.getYibanSaveList()
        },
        yibanRefresh() {
            this.yj_yiban_page = 1
            this.getYibanSaveList()
        },
        async getJinjiSaveList() {
            let _data = await getSaveList(this.xiaoqu_id, 3, this.yj_jinji_page, 4,this.xiangmu_id)
            this.yj_jinji_total_page = _data.total_page
            this.yj_jinji_list = _data.data
            let filter = this.yj_jinji_list.filter(f=>{ return f.state === 2});
            if (filter.length){
                this.cur_detail = filter[0]
                this.yijingDialog = true
            }
        },
        selectItem(item){
            this.cur_detail = item
            this.yijingDialog = true
        },
        cancelDialog(data){
            this.yijingDialog = false
            if (data)this.getJinjiSaveList()
        },
        jinjiLast() {
            if (this.yj_jinji_page <= 1) return
            this.yj_jinji_page--
            this.getJinjiSaveList()
        },
        jinjiNext() {
            if (this.yj_jinji_page === this.yj_jinji_total_page) return
            this.yj_jinji_page++
            this.getJinjiSaveList()
        },
        jinjiRefresh() {
            this.yj_jinji_page = 1
            this.getJinjiSaveList()
        },
        //  获取数据
        async init() {
            let _data = await dataScreenTotal(this.xiaoqu_id,this.xiangmu_id)
            this.push_num = _data.data.push_num
            this.jumin_equipment_num = _data.data.jumin_equipment_num
            this.zaixian_equipment_num = _data.data.zaixian_equipment_num
            this.lixian_equipment_num = _data.data.lixian_equipment_num
            this.save_order_num = _data.data.save_order_num
            this.xinlv_order_num = _data.data.xinlv_order_num
            this.tiwen_order_num = _data.data.tiwen_order_num
            this.xueyang_order_num = _data.data.xueyang_order_num
            this.xueya_order_num = _data.data.xueya_order_num
            // this.fanwei_lv =  _data.data.zaixian_equipment_num ? _data.data.zaixian_equipment_num / _data.data.jumin_equipment_num : 0
            this.fanwei_lv =  100
            _data.data.jumin_equipment.map(item => {
                item.value = [item.Longitude, item.Latitude]
                item.itemStyle = {
                    // color: '#34d0ff'
                    color: '#ff576f'
                }
            })
            this.map_data = _data.data.jumin_equipment
            this.initMap()
            this.loading = false
        },
        // 初始化地图数据
        initMap() {
            echarts.registerMap('shijingshan', geoJson);
            echarts.registerMap('shijingshan_tudi', shijingshan_tudi);
            this.mapChart = echarts.init(this.$refs.land_map)
            window.onresize = this.mapChart.resize
            this.mapChart.setOption({
                tooltip: {        // 提示框组件
                    show: true,     // 显示提示
                },
                series: {
                    type: 'scatter', //配置显示方式为用户自定义
                    coordinateSystem: 'geo',
                    roam: false,//禁止拖拽
                    data: this.map_data,
                    symbol:'pin',
                    symbolSize: 30,      // 点大小
                    tooltip: {        // 提示框组件
                        trigger: 'item',     // 触发类型
                        triggerOn: 'mousemove',  // 出发条件
                        // formatter: `{b}</br>`,
                        backgroundColor:'#ffff',
                        borderWidth:0,
                        padding:0,
                        formatter(params) {
                            const item = params.data
                            return `<div style="display: flex;flex-direction: column;justify-content: center;padding: 14px;width: 382px;height: 110px;background-color: #173979;border-radius: 10px;">
                                    <div style="display: flex;align-items: center">
                                        <div class="name" style="font-size: 18px;font-weight: 600;
                                        font-stretch: normal;line-height: 16px;letter-spacing: 0px;color: #ffffff;">${item.name}</div>
                                        <div style="font-size: 14px;color: #b1c5eb;margin-left: 10px;">${item.phone}</div>
                                    </div>
                                    <div style="font-size: 14px;color: #b1c5eb;margin-top: 10px;">${item.xiaoqu_name}${item.building_name}${item.element_name}单元${item.room_name}</div>
                            </div>`
                        },
                    },
                },
                geo:[
                    {
                        map: 'shijingshan_tudi',  // 引入地图 省份或者 国家
                        layoutCenter: ['50%', '50%'], //设置后left/right/top/bottom等属性无效
                        layoutSize: '50%',
                        roam: true, //开启鼠标缩放和漫
                        zoom: 10,
                        scaleLimit: {
                            min: 10,
                            max: 25
                        },
                        select: {
                            itemStyle: {
                                areaColor: '#b1dfff',
                                borderColor: '#105fa2',
                                // shadowBlur: 1,          // 图形阴影的模糊大小
                                // shadowOffsetX: 1        // 阴影水平方向上的偏移距离。
                            },
                            label: {
                                color: '#105fa2',
                            }

                        },
                        itemStyle: {   // 地图区域的多边形 图形样式。
                            normal: {
                                areaColor: '#ecf6ff',
                                borderColor: '#41a2ee',
                                borderWidth:2,
                                // shadowBlur: 1,          // 图形阴影的模糊大小
                                // shadowOffsetX: 1        // 阴影水平方向上的偏移距离。
                            },
                            emphasis: {
                                areaColor: '#b1dfff',
                                borderColor: '#105fa2',
                                // shadowBlur: 1,          // 图形阴影的模糊大小
                                // shadowOffsetX: 1        // 阴影水平方向上的偏移距离。
                            },

                        },
                        label: {
                            show: true,
                            position: ['50%', '50%'],
                            normal: {
                                //静态的时候展示样式
                                show: true, //是否显示地图省份得名称
                                textStyle: {
                                    color: '#105fa2',
                                    fontSize: 12,
                                    fontFamily: 'Arial'
                                },
                            },
                            emphasis: {  // 高亮状态下的样式
                                //动态展示的样式
                                color: '#105fa2'
                            }
                        }
                    },

                ]

            })

        },
        handleCommand(item) {
            this.xiaoqu_id = item.id
            this.xiaoqu_name = item.name
            this.onload()
        },
        getCurrentTime() {
            setInterval(() => {
                this.cur_time = new Date().getTime()
            }, 1000)
        }
    },
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            switch (Number(val)) {
                case 1 :
                    return '主动求救'
                case 2 :
                    return '心率异常'
                case 3 :
                    return '体温异常'
                case 4 :
                    return '血糖异常'
                case 5 :
                    return '血氧异常'
                case 6 :
                    return '血压异常'
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.container {
    height: 100vh;
    min-width: 1920px;
    min-height: 1080px;
    overflow: hidden;

    .loading {
        color: #ffffff;
        position: fixed;
        background: #33333333;
        z-index: 10;
    }

    .header-container {
        background: url(../../../assets/img/data/bg_monitoring.png) no-repeat top;
        background-size: 100% 100%;
        height: 102px;
        position: relative;
        padding: 0 36px;

        .page-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .btn-container {
            transform: skew(25deg);
            width: 152px;
            height: 48px;
            min-width: 137px;
            line-height: 48px;
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-color: #173979;
            text-align: center;
            font-size: 18px;
            color: #19caff;
            font-weight: 500;
            cursor: pointer;

            &.right {
                transform: skew(-25deg);

                .btn {
                    transform: skew(25deg);
                }
            }

            .btn {
                transform: skew(-25deg);
            }

            &.max {
                width: 282px;
            }

            &.mid {
                width: 182px;
            }
        }


    }

    .map-container {
        position: relative;
        width: 100%;
        height: calc(100vh - 102px);
        background: #ecf6ff;

        .map {
            width: 100%;
            height: 100%;
            position: fixed;
            z-index: -1;
        }
        .maps{
            width: 100%;
            height: 100%;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .yj-total-container {
            position: absolute;
            width: 404px;
            top: 20px;
            bottom: 20px;
            right: 0;

            .info-container {
                background-image: linear-gradient(0deg,
                    #0c5da388 0%,
                    #00226288 100%),
                linear-gradient(
                        #00226288,
                        #00226288);
                background-blend-mode: normal,
                normal;
                padding: 0 14px;

                .classify-title {
                    background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
                    background-size: 100% 100%;
                    width: 242px;
                    height: 41px;
                    line-height: 41px;
                    text-align: center;
                    font-size: 18px;
                    font-weight: 600;
                    color: #19caff;
                }

                .operate {
                    width: 71px;
                    height: 28px;
                    line-height: 28px;
                    text-align: center;
                    box-shadow: inset 0px 0px 8px 3px #0096ff;
                    font-size: 14px;
                    color: #19caff;
                    cursor: pointer;
                }

                .page {
                    width: 71px;
                    font-size: 14px;
                    text-align: center;
                    color: #19caff;
                }

                .yj-item {
                    height: 79px;
                    background-color: #173979;
                    border-radius: 5px;
                    margin-top: 15px;
                    margin-left: 13px;
                    position: relative;
                    padding-left: 74px;

                    &.xinlv {
                        .tip-container {
                            background-color: #2e5297;

                            .status {
                                font-size: 12px;
                                color: #78b962;
                                height: 18px;
                                line-height: 18px;
                                text-align: center;
                                background-color: #173979;
                                border-radius: 5px;
                                margin: 7px 6px 0;
                            }
                        }
                    }

                    &.error {
                        .time {
                            color: #ff576f;
                        }

                        .tip-container {
                            background-color: #ff576f;

                            .status {
                                background-color: #e6334c;
                                color: #FFFFFF;
                            }
                        }
                    }

                    .tip-container {
                        position: absolute;
                        width: 73px;
                        height: 63px;
                        background-color: #19caff;
                        border-radius: 5px;
                        top: 50%;
                        left: -13px;
                        transform: translateY(-50%);

                        .tip {
                            font-size: 16px;
                            color: #ffffff;
                            font-weight: 600;
                        }
                    }

                    .name {
                        font-size: 18px;
                        font-weight: 600;
                        color: #ffffff;
                    }

                    .phone, .address {
                        font-size: 14px;
                        color: #b1c5eb;
                    }

                    .time {
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        font-size: 12px;
                        color: #19caff;
                    }
                }
            }
        }

        .jc-total-container {
            position: absolute;
            width: 404px;
            top: 20px;
            left: 0;
            bottom: 20px;
            height: unset;
            background-image: linear-gradient(0deg,
                #0c5da399 0%,
                #00226299 100%),
            linear-gradient(
                    #00226299,
                    #00226299);
            background-blend-mode: normal,
            normal;
            padding: 24px;

            .classify-title {
                font-size: 18px;
                font-weight: 600;
                color: #19caff;
            }

            .total-container {
                background-color: #00226266;
                border-radius: 10px;
                border: 1px solid #19caff;

                &.number {
                    height: 83px;

                    .icon {
                        width: 28px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        border-radius: 28px;
                        background-color: #062b66;
                        font-size: 15px;
                        color: #34d0ff;
                    }
                }

                &.baojing {
                    width: 170px;
                    height: 170px;
                    padding: 0 16px;

                    .number-container {
                        background: linear-gradient(90deg, #ffffff01 0%, #ffffff01 10%, #062b66 50%, #ffffff01 90%, #ffffff01 100%);
                        background-blend-mode: normal, normal;
                        position: relative;
                        height: 69px;

                        .bg-icon {
                            font-size: 44px;
                            color: #34d0ff;
                            opacity: 0.2;
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }

                        &::after {
                            width: 100%;
                            height: 1px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;
                            right: 0;
                        }

                        &::before {
                            width: 100%;
                            height: 1.5px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;
                            right: 0;
                        }
                    }

                    .label {
                        margin-top: 12px;
                    }
                }

                &.online {
                    height: 170px;
                    padding: 0 16px;

                    .classify-container {
                        width: 164px;
                        height: 62px;
                        border-radius: 10px;
                        box-shadow: inset 0px 0px 8px 3px #0096ff;

                        .icon {
                            font-size: 15px;
                            color: #34d0ff;
                            margin: 0 12px;
                        }

                        .number {
                            width: 60px;
                            height: 36px;
                        }

                        .label {
                            font-size: 16px;
                        }
                    }

                    .progress-container {
                        width: 100px;
                        height: 100px;
                        position: relative;

                        .progress {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }


                .label {
                    font-size: 18px;
                    color: #ffffff;
                }

                .number {
                    width: 120px;
                    height: 36px;
                }
            }
        }

    }
}
</style>
